import { flow, makeObservable } from 'mobx';
import BaseStore from './BaseStore';
import RootStore from '.';
import { FileApi } from '@/apis';
import { ResponseData } from '@/types/http';

class FileStore extends BaseStore {
    api: FileApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            uploadFile: flow.bound,
            deleteOneFile: flow.bound
        });
        this.api = new FileApi();
    }

    *uploadFile(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.uploadFile, payload);
            if (res.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    *deleteOneFile(idFile: number) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.deleteOneFile, idFile);
            if (res.ok) {
                return true;
            }
            return false;
        } catch (error) {
        }
    }

    clean() {
        super.clean();
    }
}

export default FileStore;
